var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13917 11.8288L0.667741 11.6622L1.13917 11.8288ZM2.05063 12.7402L2.21721 13.2117H2.21721L2.05063 12.7402ZM3.57773 12.2006L3.74431 12.672L3.57773 12.2006ZM4.09278 12.2499L3.85016 12.6871L4.09278 12.2499ZM1.66148 9.74141L2.10608 9.51264L1.66148 9.74141ZM1.70095 10.2389L1.22952 10.0724L1.70095 10.2389ZM1.5 7C1.5 3.96243 3.96243 1.5 7 1.5V0.5C3.41015 0.5 0.5 3.41015 0.5 7H1.5ZM2.10608 9.51264C1.71882 8.76004 1.5 7.9063 1.5 7H0.5C0.5 8.06914 0.758515 9.07936 1.21688 9.97018L2.10608 9.51264ZM1.61061 11.9954L2.17239 10.4055L1.22952 10.0724L0.667741 11.6622L1.61061 11.9954ZM1.88404 12.2688C1.7142 12.3288 1.55059 12.1652 1.61061 11.9954L0.667741 11.6622C0.32765 12.6246 1.25475 13.5518 2.21721 13.2117L1.88404 12.2688ZM3.41114 11.7292L1.88404 12.2688L2.21721 13.2117L3.74431 12.672L3.41114 11.7292ZM7 12.5C6.03227 12.5 5.12431 12.2505 4.3354 11.8127L3.85016 12.6871C4.78373 13.2052 5.85818 13.5 7 13.5V12.5ZM12.5 7C12.5 10.0376 10.0376 12.5 7 12.5V13.5C10.5899 13.5 13.5 10.5899 13.5 7H12.5ZM7 1.5C10.0376 1.5 12.5 3.96243 12.5 7H13.5C13.5 3.41015 10.5899 0.5 7 0.5V1.5ZM3.74431 12.672C3.7676 12.6638 3.80631 12.6627 3.85016 12.6871L4.3354 11.8127C4.06383 11.662 3.72799 11.6172 3.41114 11.7292L3.74431 12.672ZM1.21688 9.97018C1.23888 10.0129 1.23744 10.0499 1.22952 10.0724L2.17239 10.4055C2.28002 10.1009 2.24277 9.77831 2.10608 9.51264L1.21688 9.97018Z",
    fill: "#667085"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.0293,
    cy: 7.03003,
    r: 0.75,
    fill: "#667085"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.0293,
    cy: 7.03003,
    r: 0.75,
    fill: "#667085"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0293,
    cy: 7.03003,
    r: 0.75,
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesMobile);
export default __webpack_public_path__ + "static/media/messagesMobile.8310070828d5528f1218e657dadd1c86.svg";
export { ForwardRef as ReactComponent };